<template>
  <div>
    <v-card
      v-if="!opened && selectedItem"
      width="600"
      class="mr-2"
      outlined
      @click="opened = true"
    >
      <v-card-text class="d-flex align-center justify-space-between">
        <div class="d-flex align-center">
          <AppAvatar
            class="mr-3"
            :userName="fullName(selectedItem)"
            :userAvatar="
              !selectedItem.isGroup ? selectedItem.avatarURL : undefined
            "
            :isGroup="selectedItem.isGroup"
            :avatarSize="selectedItem.isGroup ? '34' : '30'"
            :initialsSize="selectedItem.isGroup ? 11 : 14"
            iconSize="24"
            avatarColor="primary"
            initialsColor="secondary"
          />
          <span>{{ fullName(selectedItem) }}</span>
        </div>

        <v-icon>mdi-menu-down</v-icon>
      </v-card-text>
    </v-card>
    <v-card
      v-else
      width="600"
      :max-height="400"
      class="mr-2 d-flex flex-column"
    >
      <!-- Buscador de usuarios y grupos, fuera del scroll -->
      <v-card-text class="pt-0 pb-2 flex-shrink-0">
        <v-text-field
          v-model="managerSearch"
          clearable
          prepend-icon="mdi-magnify"
          :label="$t('searchField')"
          single-line
          hide-details
        />
        <v-divider class="mt-2 mb-2" />
      </v-card-text>

      <!-- Contenido con scroll  -->
      <!-- Mostrar lista de operadores asignables como responsable -->
      <v-card-text class="pt-0 flex-grow-1 scroll-area">
        <v-row no-gutters>
          <v-col cols="6">
            <strong>{{ $t('operators') }}</strong>
            <v-list dense>
              <v-list-item
                v-for="manager in filteredOperators"
                :key="manager.id"
                @click="selectOperator(manager)"
                :class="{
                  'v-list-item--active primary--text v-list-item--highlighted':
                    operator?.id === manager.id,
                }"
                :disabled="manager.disabled"
              >
                <AppAvatar
                  class="mr-3"
                  :userName="fullName(manager)"
                  :userAvatar="manager.avatarURL"
                  avatarSize="30"
                  iconSize="24"
                  avatarColor="primary"
                  initialsColor="secondary"
                />
                {{ fullName(manager) }}
              </v-list-item>
            </v-list>
          </v-col>

          <!-- Mostrar lista de grupos asignables como responsable -->
          <v-col cols="6">
            <strong>{{ $t('tabTitle.groups') }}</strong>
            <v-list dense>
              <v-list-item
                v-for="manager in filteredGroups"
                :key="manager.id"
                @click="selectGroup(manager)"
                :class="{
                  'v-list-item--active primary--text v-list-item--highlighted':
                    group?.id === manager.id,
                }"
                :disabled="manager.deleted"
              >
                <AppAvatar
                  class="mr-3"
                  :userName="fullName(manager)"
                  :isGroup="true"
                  avatarSize="34"
                  :initialsSize="11"
                  iconSize="24"
                  avatarColor="primary"
                  initialsColor="secondary"
                />
                {{ fullName(manager) }}
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import rules from '@/utils/rules'

export default {
  props: {
    operators: Array,
    groups: Array,
  },
  data() {
    return {
      operator: undefined,
      group: undefined,
      managerSearch: '',
      opened: false,
    }
  },
  methods: {
    ...rules,
    fullName(obj, nameKey = 'name', surnameKey = 'surname') {
      if (!obj) return ''
      if (obj.fullName) return obj.fullName

      return [obj[nameKey], obj[surnameKey]]
        .filter((value) => typeof value === 'string' && value.trim() !== '')
        .join(' ')
    },
    selectOperator(op) {
      this.operator = { ...op, isGroup: false }
      this.group = undefined
      this.opened = false // cerrar el selector
    },
    selectGroup(grp) {
      this.group = { ...grp, isGroup: true }
      this.operator = undefined
      this.opened = false // cerrar el selector
    },
  },
  computed: {
    filteredOperators() {
      if (!this.managerSearch) return this.operators
      if (!this.operators.length) return
      return this.operators.filter((manager) => {
        // String de búsqueda en mayúscula
        const searchCap = this.managerSearch
          ? this.managerSearch.toUpperCase()
          : ''
        const { fullName } = manager

        // Guardamos los elementos en mayúscula
        let nameCap = fullName?.toUpperCase()
        // Filtramos
        if (nameCap?.includes(searchCap)) return manager
      })
    },
    filteredGroups() {
      if (!this.managerSearch) return this.groups
      if (!this.groups.length) return
      return this.groups.filter((manager) => {
        // String de búsqueda en mayúscula
        const searchCap = this.managerSearch
          ? this.managerSearch.toUpperCase()
          : ''
        const { fullName } = manager

        // Guardamos los elementos en mayúscula
        let nameCap = fullName?.toUpperCase()
        // Filtramos
        if (nameCap?.includes(searchCap)) return manager
      })
    },
    selectedItem() {
      return this.operator || this.group
    },
  },
  watch: {
    operator: function (newValue) {
      if (newValue) this.$emit('setOperator', newValue)
    },
    group: function (newValue) {
      if (newValue) this.$emit('setGroup', newValue)
    },
  },
}
</script>
<style lang="scss" scoped>
.scroll-area {
  overflow-y: auto;
}
</style>
